import { Theme } from '@mui/material'

const useStyles = {
  // Leak & Freeze styles
  mainContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '60px',
    gap: 3,
    height: 'calc(100% - 93px)',
  },
  titleText: {
    fontWeight: '300',
    textAlign: 'center',
  },
  activatedText: {
    textAlign: 'center',
  },
  leakFreezeLocationInformation: {
    opacity: 0.8,
    flexDirection: 'column',
    gap: 1,
  },
  locationLabel: {
    textAlign: 'center',
    fontWeight: '500',
    fontStyle: 'italic',
    fontSize: '13px',
    lineHeight: '1.2',
    letterSpacing: '0',
    width: '100%',
  },
  locationValue: {
    textAlign: 'center',
  },
  leakFreezeFooter: {
    height: 'auto',
  },

  // Slim styles
  slimHeaderTitle: (theme: Theme) => ({
    textAlign: 'center',
    width: '100%',
    color: theme.palette.common.white,
  }),
  slimMainContainer: {
    rowGap: 2,
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  slimLocationSection: {
    marginTop: 3,
  },
  slimLocationContainer: {
    justifyContent: 'center',
  },
  slimLocationText: (theme: Theme) => ({
    color: theme.palette.common.white,
  }),
  slimImageContainer: {
    justifyContent: 'center',
  },
  slimStatusContainer: {
    justifyContent: 'center',
    marginTop: 3,
  },
  slimOfflineTitle: (theme: Theme) => ({
    textAlign: 'center',
    fontWeight: '600',
    lineHeight: '24px',
    letterSpacing: '0.25px',
    color: theme.palette.common.white,
  }),
  slimOfflineText: (theme: Theme) => ({
    textAlign: 'center',
    lineHeight: '24px',
    letterSpacing: '0.25px',
    color: theme.palette.common.white,
  }),
  slimOnlineTitle: (theme: Theme) => ({
    textAlign: 'center',
    fontSize: '34px',
    fontWeight: '300',
    lineHeight: '44px',
    letterSpacing: '0px',
    color: theme.palette.common.white,
  }),
  slimOnlineText: (theme: Theme) => ({
    textAlign: 'center',
    lineHeight: '24px',
    letterSpacing: '0.25px',
    maxWidth: '254px',
    color: theme.palette.common.white,
  }),
  slimButtonsWrapper: (isShortScreen: boolean) => ({
    marginTop: isShortScreen ? 4 : 9,
  }),
  slimButtonsContainer: {
    columnGap: 2,
    justifyContent: 'center',
  },
  slimHomeButtonContainer: {
    marginTop: 2,
  },
  slimOutlinedButton: (theme: Theme) => ({
    '&.MuiButton-outlined': {
      color: theme.palette.common.white,
      borderColor: theme.palette.common.white,
    },
  }),
}

export default useStyles
